import { required } from '@polvo-labs/form-utils'
import { useRequest } from '@polvo-labs/react-auth'
import React from 'react'
import Form from '../../../components/Form'
import TextArea from '../../../components/Form/Fields/TextArea'
import FieldType from '../../../components/Form/Fields/type'

export interface StatusMessageFormData {
  message: string
}
interface Props {
  buttonLabel?: string
  initialValues?: StatusMessageFormData
  onSubmit: (data: any) => void
}

const StatusMessageForm: React.FC<Props> = ({ initialValues, onSubmit, buttonLabel = 'Pendente de Documentos' }) => {
  const { request } = useRequest()
  const fields: FieldType<keyof StatusMessageFormData>[] = [
    {
      name: 'message',
      component: TextArea,
      validation: required,
      data: {},
      html: {},
    }]


  return (
    <Form<StatusMessageFormData>
      buttonLabel={buttonLabel}
      fields={fields}
      onSubmit={(data, form) => {
        onSubmit(data)
      }}
    />
  )
}

export default StatusMessageForm
